import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.9999 9.85834V14.525M15.4537 4.03526L16.8782 5.24917C17.237 5.555 17.6826 5.73989 18.1527 5.7774L20.0182 5.92608C21.115 6.01361 21.9862 6.88426 22.0738 7.98108L22.2221 9.84694C22.2596 10.317 22.4451 10.7632 22.751 11.1221L23.9643 12.5461C24.678 13.3836 24.6781 14.6155 23.9645 15.4529L22.7511 16.8772C22.4453 17.2361 22.2599 17.6825 22.2224 18.1525L22.0732 20.018C21.9857 21.1149 21.1158 21.9861 20.019 22.0736L18.1528 22.2225C17.6828 22.26 17.2367 22.4444 16.8779 22.7502L15.4537 23.9642C14.6163 24.6779 13.3836 24.678 12.5462 23.9643L11.122 22.7503C10.7631 22.4445 10.3171 22.2598 9.84711 22.2223L7.9809 22.0736C6.88408 21.9861 6.01423 21.1151 5.9267 20.0182L5.77745 18.1526C5.73994 17.6826 5.55463 17.2366 5.24881 16.8777L4.03543 15.453C3.32175 14.6155 3.32141 13.384 4.03509 12.5466L5.24956 11.1218C5.55539 10.763 5.73892 10.317 5.77643 9.84694L5.92568 7.9813C6.0132 6.88448 6.88557 6.01349 7.98239 5.92596L9.84654 5.77728C10.3166 5.73978 10.7628 5.55503 11.1217 5.24921L12.5463 4.03526C13.3837 3.32158 14.6163 3.32158 15.4537 4.03526ZM14.0581 18.025V18.1417L13.9418 18.1412V18.025H14.0581Z",
      stroke: "#F97316",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }